import React from 'react';
import { businessInfo } from '../data/mock';
import { Phone, MapPin, Wrench } from 'lucide-react';

const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center bg-[#1a1c1b] pt-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f97316' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }} />
      </div>

      <div className="container mx-auto px-5 md:px-10 relative z-10">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#4a2a10] text-[#f97316] px-4 py-2 rounded-full mb-8">
            <Wrench size={16} />
            <span className="text-sm font-medium uppercase tracking-wide">Eskişehir'in Güvenilir Servisi</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-[#f97316] font-black text-5xl md:text-7xl lg:text-8xl leading-[0.85] uppercase mb-6">
            Küçük Ev<br />
            Aletleri<br />
            <span className="text-[#888680]">Tamiri</span>
          </h1>

          {/* Description */}
          <p className="text-[#888680] text-lg md:text-xl max-w-xl mb-10 leading-relaxed">
            {businessInfo.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a
              href={`tel:${businessInfo.phone.replace(/\s/g, '')}`}
              className="inline-flex items-center justify-center gap-2 bg-[#f97316] text-white px-8 py-4 rounded-full font-semibold text-base uppercase tracking-wide hover:scale-[1.02] active:scale-[0.98] transition-transform duration-300"
            >
              <Phone size={20} />
              <span>Hemen Ara</span>
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center gap-2 border border-[#f97316] text-[#f97316] px-8 py-4 rounded-full font-semibold text-base uppercase tracking-wide hover:bg-[#f97316] hover:text-white transition-all duration-300"
            >
              <span>Hizmetlerimiz</span>
            </a>
          </div>

          {/* Location */}
          <div className="flex items-start gap-3 text-[#888680]">
            <MapPin size={20} className="text-[#f97316] flex-shrink-0 mt-1" />
            <span className="text-sm md:text-base">{businessInfo.address}</span>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute right-0 bottom-0 w-1/3 h-1/2 bg-gradient-to-tl from-[#4a2a10]/20 to-transparent pointer-events-none" />
    </section>
  );
};

export default HeroSection;
